[
  {
    "id": "1-1",
    "name": "First Light",
    "hint": "Gravity pulls light. Drag the moon near the beam and watch it bend into the telescope.",
    "sources": [{ "x": 120, "y": 460, "angle": 0, "color": 7 }],
    "receivers": [{ "x": 1056, "y": 371, "color": 7 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "moon": 1 },
    "par": 1,
    "solution": [{ "kind": "moon", "x": 430, "y": 392 }]
  },
  {
    "id": "1-2",
    "name": "Closer Bends More",
    "hint": "The nearer a beam passes a mass, the harder it bends.",
    "sources": [{ "x": 120, "y": 640, "angle": 0, "color": 7 }],
    "receivers": [{ "x": 1014, "y": 503, "color": 7 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "moon": 1 },
    "par": 1,
    "solution": [{ "kind": "moon", "x": 290, "y": 588 }]
  },
  {
    "id": "1-3",
    "name": "Weight of a Star",
    "hint": "Stars are heavier than moons: they bend light harder, from farther away.",
    "sources": [{ "x": 100, "y": 700, "angle": 0, "color": 7 }],
    "receivers": [{ "x": 1108, "y": 487, "color": 7 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "star": 1 },
    "par": 2,
    "solution": [{ "kind": "star", "x": 250, "y": 615 }]
  },
  {
    "id": "1-4",
    "name": "One Pull, Two Beams",
    "hint": "A mass bends every beam that passes it. Pull both beams together.",
    "sources": [
      { "x": 120, "y": 240, "angle": 0, "color": 7 },
      { "x": 120, "y": 560, "angle": 0, "color": 7 }
    ],
    "receivers": [
      { "x": 849, "y": 337, "color": 7 },
      { "x": 849, "y": 463, "color": 7 }
    ],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "giant": 1 },
    "par": 3,
    "solution": [{ "kind": "giant", "x": 480, "y": 400 }]
  },
  {
    "id": "1-5",
    "name": "Near and Far",
    "hint": "One mass, two beams: the nearer beam bends more than the far one.",
    "sources": [
      { "x": 120, "y": 160, "angle": 0, "color": 7 },
      { "x": 120, "y": 300, "angle": 0, "color": 7 }
    ],
    "receivers": [
      { "x": 1062, "y": 204, "color": 7 },
      { "x": 1060, "y": 449, "color": 7 }
    ],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "star": 1 },
    "par": 2,
    "solution": [{ "kind": "star", "x": 480, "y": 390 }]
  },
  {
    "id": "1-6",
    "name": "Crosstalk",
    "hint": "Each mass pulls on every beam. Spread the beams apart without disturbing the other.",
    "sources": [
      { "x": 120, "y": 300, "angle": 0, "color": 7 },
      { "x": 120, "y": 500, "angle": 0, "color": 7 }
    ],
    "receivers": [
      { "x": 1067, "y": 203, "color": 7 },
      { "x": 1067, "y": 597, "color": 7 }
    ],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "moon": 2 },
    "par": 2,
    "solution": [
      { "kind": "moon", "x": 420, "y": 245 },
      { "kind": "moon", "x": 420, "y": 555 }
    ]
  },
  {
    "id": "1-7",
    "name": "The Lens",
    "hint": "This beacon shines a fan of two beams. The telescope needs both: bring them together.",
    "sources": [{ "x": 120, "y": 400, "angle": 0, "color": 7, "beams": 2, "spread": 10 }],
    "receivers": [{ "x": 1000, "y": 400, "color": 7, "count": 2 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "moon": 1 },
    "par": 1,
    "solution": [{ "kind": "moon", "x": 682, "y": 400 }]
  },
  {
    "id": "1-8",
    "name": "Off Axis",
    "hint": "Pass one beam closer than the other and the focus moves aside.",
    "sources": [{ "x": 120, "y": 200, "angle": 25, "color": 7, "beams": 2, "spread": 18 }],
    "receivers": [{ "x": 967, "y": 560, "color": 7, "count": 2 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "star": 1 },
    "par": 2,
    "solution": [{ "kind": "star", "x": 560, "y": 420 }]
  },
  {
    "id": "1-9",
    "name": "Three as One",
    "hint": "Three beams, one telescope. A single mass would block the middle beam.",
    "sources": [{ "x": 120, "y": 400, "angle": 0, "color": 7, "beams": 3, "spread": 11 }],
    "receivers": [{ "x": 847, "y": 400, "color": 7, "count": 3 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "moon": 2 },
    "par": 2,
    "solution": [
      { "kind": "moon", "x": 540, "y": 355 },
      { "kind": "moon", "x": 540, "y": 445 }
    ]
  },
  {
    "id": "1-10",
    "name": "Gravitational Lens",
    "hint": "Focus the fan, then send the lone beam home. Every mass tugs on every beam.",
    "sources": [
      { "x": 120, "y": 300, "angle": 0, "color": 7, "beams": 3, "spread": 11 },
      { "x": 120, "y": 620, "angle": 0, "color": 7 }
    ],
    "receivers": [
      { "x": 836, "y": 321, "color": 7, "count": 3 },
      { "x": 1091, "y": 732, "color": 7 }
    ],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "moon": 2, "star": 1 },
    "par": 4,
    "solution": [
      { "kind": "moon", "x": 540, "y": 255 },
      { "kind": "moon", "x": 540, "y": 345 },
      { "kind": "star", "x": 600, "y": 700 }
    ]
  },
  {
    "id": "2-1",
    "name": "Two Colours",
    "receivers": [
      { "x": 1000, "y": 522, "color": 1 },
      { "x": 1000, "y": 278, "color": 7 }
    ],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "star": 1 },
    "par": 2,
    "sources": [
      { "x": 120, "y": 330, "angle": 0, "color": 1 },
      { "x": 120, "y": 470, "angle": 0, "color": 7 }
    ],
    "solution": [{ "kind": "star", "x": 470, "y": 400 }],
    "hint": "Telescopes want one colour. A mass between two beams makes them cross."
  },
  {
    "id": "2-2",
    "name": "Stone Wall",
    "sources": [{ "x": 120, "y": 470, "angle": 0, "color": 7 }],
    "receivers": [{ "x": 1060, "y": 300, "color": 7 }],
    "walls": [{ "x1": 640, "y1": 430, "x2": 640, "y2": 720 }],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "star": 1 },
    "par": 2,
    "solution": [{ "kind": "star", "x": 415, "y": 381 }],
    "hint": "Walls stop light. Bend the beam over the top of the wall."
  },
  {
    "id": "2-3",
    "name": "Counterweight",
    "receivers": [{ "x": 1082, "y": 378, "color": 7 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [{ "kind": "star", "x": 520, "y": 510 }],
    "inventory": { "moon": 1, "star": 1 },
    "par": 1,
    "sources": [{ "x": 120, "y": 400, "angle": 0, "color": 7 }],
    "solution": [{ "kind": "moon", "x": 470, "y": 352 }],
    "hint": "Engraved masses cannot be moved. Balance the pull of the fixed star."
  },
  {
    "id": "2-4",
    "name": "Mixing Light",
    "receivers": [{ "x": 1024, "y": 401, "color": 3, "count": 2 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "giant": 1, "star": 1 },
    "par": 3,
    "sources": [
      { "x": 120, "y": 250, "angle": 0, "color": 1 },
      { "x": 120, "y": 550, "angle": 0, "color": 2 }
    ],
    "solution": [{ "kind": "giant", "x": 520, "y": 400 }],
    "hint": "Light mixes: red and green arriving together make yellow."
  },
  {
    "id": "2-5",
    "name": "Slingshot",
    "sources": [{ "x": 120, "y": 700, "angle": -20, "color": 7 }],
    "receivers": [{ "x": 760, "y": 90, "color": 7 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [{ "kind": "giant", "x": 700, "y": 400 }],
    "inventory": { "moon": 1 },
    "par": 1,
    "solution": [{ "kind": "moon", "x": 375, "y": 419 }],
    "hint": "Throw the beam round the fixed giant. Your moon sets the approach."
  },
  {
    "id": "2-6",
    "name": "Pure Colour",
    "sources": [
      { "x": 120, "y": 300, "angle": 0, "color": 1 },
      { "x": 120, "y": 450, "angle": 0, "color": 7 }
    ],
    "receivers": [
      { "x": 1060, "y": 452, "color": 1 },
      { "x": 1060, "y": 640, "color": 7 }
    ],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "moon": 1, "star": 1 },
    "par": 3,
    "solution": [
      { "kind": "moon", "x": 668, "y": 357 },
      { "kind": "star", "x": 498, "y": 517 }
    ],
    "hint": "A telescope needs exactly its colour. Keep the white beam out of the red one."
  },
  {
    "id": "2-7",
    "name": "Dust Cloud",
    "sources": [
      { "x": 120, "y": 360, "angle": 0, "color": 1 },
      { "x": 120, "y": 440, "angle": 0, "color": 7 }
    ],
    "receivers": [
      { "x": 1080, "y": 210, "color": 1 },
      { "x": 1080, "y": 590, "color": 7 }
    ],
    "walls": [],
    "rocks": [],
    "dust": [{ "x": 680, "y": 400, "r": 85 }],
    "nebulae": [],
    "fixed": [],
    "inventory": { "star": 2, "giant": 1 },
    "par": 4,
    "solution": [
      { "kind": "star", "x": 376, "y": 292 },
      { "kind": "star", "x": 358, "y": 511 }
    ],
    "hint": "Dust swallows light. Part the beams around the cloud."
  },
  {
    "id": "2-8",
    "name": "Asteroid Field",
    "sources": [{ "x": 100, "y": 230, "angle": 12, "color": 7 }],
    "receivers": [{ "x": 1054, "y": 518, "color": 7 }],
    "walls": [],
    "rocks": [
      { "x": 539, "y": 11, "r": 31 },
      { "x": 544, "y": 54, "r": 33 },
      { "x": 541, "y": 93, "r": 28 },
      { "x": 543, "y": 136, "r": 29 },
      { "x": 539, "y": 178, "r": 33 },
      { "x": 549, "y": 220, "r": 29 },
      { "x": 535, "y": 261, "r": 32 },
      { "x": 540, "y": 306, "r": 28 },
      { "x": 540, "y": 344, "r": 32 },
      { "x": 540, "y": 477, "r": 31 },
      { "x": 539, "y": 513, "r": 27 },
      { "x": 529, "y": 556, "r": 33 },
      { "x": 529, "y": 594, "r": 31 },
      { "x": 529, "y": 633, "r": 29 },
      { "x": 547, "y": 673, "r": 28 },
      { "x": 529, "y": 711, "r": 31 },
      { "x": 548, "y": 752, "r": 28 },
      { "x": 547, "y": 790, "r": 30 }
    ],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "moon": 1, "star": 1 },
    "par": 3,
    "solution": [
      { "kind": "moon", "x": 242, "y": 301 },
      { "kind": "star", "x": 610, "y": 349 }
    ],
    "hint": "Thread the beam through the gap in the belt. One bend will not do."
  },
  {
    "id": "2-9",
    "name": "Detour",
    "sources": [{ "x": 120, "y": 400, "angle": 0, "color": 7 }],
    "receivers": [{ "x": 1079, "y": 398, "color": 7 }],
    "walls": [],
    "rocks": [{ "x": 600, "y": 400, "r": 40 }],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "moon": 2, "star": 1 },
    "par": 2,
    "solution": [
      { "kind": "moon", "x": 284, "y": 334 },
      { "kind": "moon", "x": 729, "y": 376 }
    ],
    "hint": "Out around the rock and back again: two bends. Two moons can do it, if you are precise."
  },
  {
    "id": "2-10",
    "name": "Inversion",
    "receivers": [
      { "x": 1066, "y": 552, "color": 1 },
      { "x": 1082, "y": 400, "color": 2 },
      { "x": 1066, "y": 248, "color": 4 }
    ],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "moon": 2, "star": 1 },
    "par": 2,
    "sources": [
      { "x": 120, "y": 320, "angle": 0, "color": 1 },
      { "x": 120, "y": 400, "angle": 0, "color": 2 },
      { "x": 120, "y": 480, "angle": 0, "color": 4 }
    ],
    "solution": [
      { "kind": "moon", "x": 500, "y": 360 },
      { "kind": "moon", "x": 500, "y": 440 }
    ],
    "hint": "A lens turns the picture upside down. Send each colour to its own telescope."
  },
  {
    "id": "3-1",
    "name": "Event Horizon",
    "sources": [{ "x": 120, "y": 420, "angle": 0, "color": 7 }],
    "receivers": [{ "x": 787, "y": 628, "color": 7 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [{ "kind": "hole", "x": 640, "y": 482 }],
    "inventory": { "moon": 1 },
    "par": 1,
    "solution": [{ "kind": "moon", "x": 260, "y": 300 }],
    "hint": "Black holes swallow any beam that comes too close. Steer the beam so it is flung, not eaten."
  },
  {
    "id": "3-2",
    "name": "U-Turn",
    "sources": [{ "x": 120, "y": 190, "angle": 0, "color": 7 }],
    "receivers": [{ "x": 816, "y": 486, "color": 7 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [{ "kind": "hole", "x": 780, "y": 290 }],
    "inventory": { "moon": 1 },
    "par": 1,
    "solution": [{ "kind": "moon", "x": 308, "y": 348 }],
    "hint": "Just outside a black hole, light can swing right round. A gentle nudge goes a long way."
  },
  {
    "id": "3-3",
    "name": "Push",
    "sources": [{ "x": 120, "y": 330, "angle": 0, "color": 7 }],
    "receivers": [{ "x": 1122, "y": 416, "color": 7 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "void": 1 },
    "par": 2,
    "solution": [{ "kind": "void", "x": 968, "y": 300 }],
    "hint": "A void is negative mass: it pushes light away. Put it on the far side of the beam."
  },
  {
    "id": "3-4",
    "name": "Push and Pull",
    "sources": [
      { "x": 120, "y": 300, "angle": 0, "color": 1 },
      { "x": 120, "y": 470, "angle": 0, "color": 4 }
    ],
    "receivers": [
      { "x": 1121, "y": 167, "color": 1 },
      { "x": 1127, "y": 333, "color": 4 }
    ],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "moon": 1, "void": 1 },
    "par": 3,
    "solution": [
      { "kind": "moon", "x": 420, "y": 230 },
      { "kind": "void", "x": 664, "y": 540 }
    ],
    "hint": "Pull one beam, push the other. Both must climb, the lower one more."
  },
  {
    "id": "3-5",
    "name": "Red Nebula",
    "sources": [{ "x": 120, "y": 620, "angle": 0, "color": 7 }],
    "receivers": [{ "x": 1129, "y": 405, "color": 1 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [{ "x": 640, "y": 420, "r": 110, "color": 1 }],
    "fixed": [],
    "inventory": { "star": 1 },
    "par": 2,
    "solution": [{ "kind": "star", "x": 208, "y": 540 }],
    "hint": "Nebulae tint the light that passes through. This telescope wants red."
  },
  {
    "id": "3-6",
    "name": "Filter",
    "sources": [
      { "x": 120, "y": 290, "angle": 0, "color": 7 },
      { "x": 120, "y": 540, "angle": 0, "color": 2 }
    ],
    "receivers": [
      { "x": 1126, "y": 410, "color": 1 },
      { "x": 1123, "y": 517, "color": 2 }
    ],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [{ "x": 640, "y": 430, "r": 95, "color": 1 }],
    "fixed": [],
    "inventory": { "moon": 1, "star": 1 },
    "par": 1,
    "solution": [{ "kind": "moon", "x": 172, "y": 348 }],
    "hint": "A red nebula lets only red through: white turns red, green is lost."
  },
  {
    "id": "3-7",
    "name": "Accretion",
    "sources": [{ "x": 120, "y": 330, "angle": 5, "color": 7, "beams": 3, "spread": 12 }],
    "receivers": [{ "x": 701, "y": 306, "color": 7, "count": 2 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [{ "kind": "hole", "x": 640, "y": 430 }],
    "inventory": { "moon": 1 },
    "par": 1,
    "solution": [{ "kind": "moon", "x": 232, "y": 516 }],
    "hint": "The hole will eat one beam of the fan. Let it, and focus the other two."
  },
  {
    "id": "3-8",
    "name": "White Light",
    "receivers": [{ "x": 788, "y": 400, "color": 7, "count": 3 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [],
    "inventory": { "moon": 2, "star": 1 },
    "par": 2,
    "sources": [
      { "x": 120, "y": 310, "angle": 0, "color": 1 },
      { "x": 120, "y": 400, "angle": 0, "color": 2 },
      { "x": 120, "y": 490, "angle": 0, "color": 4 }
    ],
    "solution": [
      { "kind": "moon", "x": 520, "y": 355 },
      { "kind": "moon", "x": 520, "y": 445 }
    ],
    "hint": "Red, green and blue together make white. Gather all three."
  },
  {
    "id": "3-9",
    "name": "Dark Lens",
    "sources": [
      { "x": 120, "y": 330, "angle": 0, "color": 1 },
      { "x": 120, "y": 520, "angle": 0, "color": 4 }
    ],
    "receivers": [{ "x": 742, "y": 375, "color": 5, "count": 2 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [],
    "fixed": [{ "kind": "hole", "x": 560, "y": 440 }],
    "inventory": { "void": 1, "moon": 1 },
    "par": 2,
    "solution": [{ "kind": "void", "x": 608, "y": 408 }],
    "hint": "A black hole is a lens too. Red and blue arriving together make magenta."
  },
  {
    "id": "3-10",
    "name": "Einstein Ring",
    "sources": [{ "x": 110, "y": 400, "angle": -3, "color": 7, "beams": 3, "spread": 14 }],
    "receivers": [{ "x": 933, "y": 383, "color": 5, "count": 2 }],
    "walls": [],
    "rocks": [],
    "dust": [],
    "nebulae": [
      { "x": 520, "y": 270, "r": 75, "color": 1 },
      { "x": 520, "y": 560, "r": 75, "color": 4 }
    ],
    "fixed": [{ "kind": "hole", "x": 560, "y": 420 }],
    "inventory": { "moon": 1, "void": 1 },
    "par": 1,
    "solution": [{ "kind": "moon", "x": 260, "y": 492 }],
    "hint": "Light from behind a black hole reaches you round both sides at once."
  }
]
